import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e6ca3aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "d-flex align-items-center",
  style: {"position":"relative","flex":"1","min-width":"230px"}
}
const _hoisted_2 = { class: "card w-100 h-100" }
const _hoisted_3 = { class: "card-header px-3 header-card" }
const _hoisted_4 = { class: "d-flex gap-3 align-items-center w-100" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "d-flex justify-content-between gap-4 flex-grow-1" }
const _hoisted_7 = {
  class: "m-0 p-0 titulo_card",
  style: {"width":"max-content"}
}
const _hoisted_8 = { class: "fw-bolder fs-7" }
const _hoisted_9 = { class: "card-body d-flex pb-2 pt-3 px-0 align-items-center" }
const _hoisted_10 = { class: "d-flex flex-column align-items-center flex-grow-1" }
const _hoisted_11 = { class: "m-0 fw-bolder" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "legenda m-0" }, "Quantidade", -1))
const _hoisted_13 = {
  key: 0,
  class: "line"
}
const _hoisted_14 = {
  key: 1,
  class: "d-flex flex-column align-items-center flex-grow-1"
}
const _hoisted_15 = { class: "m-0 fw-bolder" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "legenda m-0" }, "Dias p/ retorno", -1))
const _hoisted_17 = {
  key: 0,
  class: "line px-2 my-1"
}
const _hoisted_18 = {
  key: 1,
  class: "card-footer p-0 d-flex flex-column align-items-center flex-grow-1"
}
const _hoisted_19 = { class: "fw-bolder m-0" }
const _hoisted_20 = { class: "legenda m-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.iconFilename)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: require(`@/assets/filter/${_ctx.iconFilename}`)
              }, null, 8, _hoisted_5))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.title), 1),
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.percentage ? _ctx.percentage : "0"), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.quantity ? _ctx.quantity : "0"), 1),
          _hoisted_12
        ]),
        (_ctx.line)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13))
          : _createCommentVNode("", true),
        (_ctx.title == 'Finalizados')
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.mediaDiasParaRetorno ? _ctx.mediaDiasParaRetorno : "0"), 1),
              _hoisted_16
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.displayValorFaturado)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17))
        : _createCommentVNode("", true),
      (_ctx.displayValorFaturado)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.value ? _ctx.value.toLocaleString("pt-BR", { style: "currency", currency: "BRL" }) : "-"), 1),
            _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.title === 'Orçamentos' ? "Valor orçado": "Valor Faturado"), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ]))
}